export default {"src":"/_next/static/media/consent.77a0789c.svg","height":16,"width":16};